<button
    class="border border-dashed border-neutral-2 text-primary rounded hover:bg-secondary focus-visible:shadow-none focus-visible:bg-secondary transition-colors h-full w-full"
>
    <vwui-icon iconName="vwui-add" class="h-4 w-4 block m-auto"></vwui-icon>
</button>
